export const InventoryFormAction = Object.freeze({
	Hide: 1,
	Show: 2,
	Set: 3,
	ShowBubble: 4,
	HideBubble: 5,
	ShowHelp: 6,
	HideHelp: 7,
	QuestionHelp: 8,
	Clear: 9,
	Validate: 10
});

export const InventoryFormActionTypes = [
	{ value: InventoryFormAction.Hide, text: 'Hide' },
	{ value: InventoryFormAction.Show, text: 'Show' },
	{ value: InventoryFormAction.Set, text: 'Set' },
	{ value: InventoryFormAction.Validate, text: 'Validate' },
	{ value: InventoryFormAction.Clear, text: 'Clear' },
	{ value: InventoryFormAction.ShowBubble, text: 'Show Bubble' },
	{ value: InventoryFormAction.HideBubble, text: 'Hide Bubble' },
	{ value: InventoryFormAction.ShowHelp, text: 'Show Help' },
	{ value: InventoryFormAction.HideHelp, text: 'Hide Help' },
	{
		value: InventoryFormAction.QuestionHelp,
		text: 'Question Help',
		disabled: true,
	},
];
